var cov_1khm2cqtcp = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/index.ts",
      hash = "1c1d88dbaba06c74913c6218f42aa08128f6cf39",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import classname from './classname';
import * as clone from './clone';
import * as color from './color';
import * as flat from './flat';
import * as func from './func';
import hash from './hash';
import * as is from './is';
import * as number from './numbers';
import * as objects from './objects';
import shallowEqual from './shallowEqual';
import * as string from './strings';
import * as tree from './tree';
import * as detect from './dom/detect';
import * as doc from './dom/document';
import * as element from './dom/element';
import normalizeWheel from './dom/normalizeWheel';
import * as position from './dom/popover';
import ready from './dom/ready';
import isJson from './validate/isJson';
import validate from './validate';
import cssAccessors from './css-accessors';
import cssInject from './vars-inject';
import accept from './accept';
export { classname, clone, color, flat, func, hash, is, number, objects, shallowEqual, string, tree, detect, doc, element, normalizeWheel, position, ready, isJson, validate, cssAccessors, cssInject, accept };